// Same-app return paths for flows that leave the SPA, such as hosted checkout.
// Anything that is not a plain path on this origin, or that would loop back
// into the auth and billing pages, is ignored rather than followed.
const LOOPING_PATHS =
  /^\/(login|logout|register|subscribe|subscription|pricing)(\/|$)/i;
// Where signing in or registering may continue to: any page of this app except
// the auth pages themselves, which would loop.
const AUTH_PATHS =
  /^\/(login|logout|register|forgot-password|reset-password|verify-email)(\/|$)/i;

function plainAppPath(value) {
  if (typeof value !== "string" || !value || value.length > 512) return false;
  if (value.charAt(0) !== "/" || value.charAt(1) === "/") return false;
  // Backslashes, whitespace and control characters are never part of an app path.
  return !/[\\\s\u0000-\u001f\u007f]/.test(value);
}

export function safeInternalPath(value) {
  if (!plainAppPath(value) || LOOPING_PATHS.test(value.split(/[?#]/)[0]))
    return null;
  return value;
}

export function safeAuthNext(value) {
  if (!plainAppPath(value) || AUTH_PATHS.test(value.split(/[?#]/)[0]))
    return null;
  return value;
}
